import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { DeviceModel } from 'src/app/models/entities/device-model';
import { Portal } from 'src/app/models/entities/portal';
import { Terminal } from 'src/app/models/entities/terminal';
import { TerminalHistory } from 'src/app/models/entities/terminal-history';
import { DeviceModelService } from 'src/app/services/device-model.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PortalService } from 'src/app/services/portal.service';
import { TerminalHistoryService } from 'src/app/services/terminal-history.service';
import { TerminalService } from 'src/app/services/terminal.service';

@Component({
  selector: 'app-terminal-add',
  templateUrl: './terminal-add.component.html',
  styleUrls: ['./terminal-add.component.css']
})
export class TerminalAddComponent implements OnInit {
  destroy$ = new Subject<void>();
  portals$: Observable<Portal[]>;
  deviceModels$: Observable<DeviceModel[]>;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private terminalService: TerminalService,
    private portalService: PortalService,
    private deviceModelService: DeviceModelService,
    //private terminalHistoryService: TerminalHistoryService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.loadDatas();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      terminalId: ["", Validators.required],
      imei: [""],
      portalId: ["", Validators.required],
      deviceModelId: [""],
      terminalStatus: false,
      isActive: true
    })
  }


  loadDatas() {
    this.portals$ = this.portalService.getList().pipe(map(result => result.data));
    this.deviceModels$ = this.deviceModelService.getList().pipe(map(result => result.data));
  }

  add() {
    if (this.form.valid) {
      const terminal: Terminal = this.form.getRawValue();
      terminal.deviceModelId = (terminal.deviceModelId === null || terminal.deviceModelId === undefined) ? 0 : terminal.deviceModelId;
      terminal.userId = this.userService.getUserId();
      this.terminalService.add(terminal).pipe(
        takeUntil(this.destroy$)
      ).subscribe(
        () => {
          this.toastrService.success("Terminal kayıt işlemi başarıyla gerçekleştirildi.", "Başarılı");
          this.router.navigateByUrl('/terminal');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();
  }



}
